import 'babel-polyfill';
import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import './assets/styles/FontSizeUtilities.css';
import Loader from './components/common/Loader/Loader';
import LocaleUrlSync from './components/common/LocalizationContext/LocaleUrlSync';
import TranslatorProvider from './components/common/LocalizationContext/TranslatorProvider';
import { history } from './store/store';
import TempEdge from './TempEdge';

const App = () => (
  <HelmetProvider>
    <TranslatorProvider>
      <HistoryRouter history={history}>
        <LocaleUrlSync />
        <Suspense fallback={<Loader />}>
          <TempEdge />
        </Suspense>
      </HistoryRouter>
    </TranslatorProvider>
  </HelmetProvider>
);

export default App;
